const modal = {
  cancelButton: 'Cancelar',
  confirmButton: 'Confirmar',
};

export default modal;
